export const ProductGroupStatusTypes = {
  VISIBLE: 1,
  INVISIBLE: 2,
}
